<template>
  <v-dialog v-model="dialog" width="700">
    <template v-slot:activator="{on}">
      <slot name="activator">
        <v-btn v-on="on" small  icon>
          <v-icon color="blue darken-2">mdi-information</v-icon>
        </v-btn>
      </slot>
    </template>
    <v-sheet>
      <div>
        <v-progress-linear indeterminate v-if="!item.sign"></v-progress-linear>
        <v-container v-else-if="!item.sign.verification.certificate &&
            !item.sign.verification.hash && !item.sign.verification.signature">
          <h2 style="text-align: center">Brak podpisu</h2>
        </v-container>
        <v-tabs
            v-model="active"
            v-else
            color="gray"
            dark
            centered
            slider-color="yellow"
        >
          <v-tab ripple >
            Podpis
          </v-tab>
          <v-tab-item>
            <v-card  v-if="item.sign" flat>
              <v-container>
                <table class="signature-table">
                  <tr>
                    <td class="signature-td">Nazwa</td>
                    <td class="signature-td">{{ item.sign.subject.common_name || "Brak" }}</td>
                  </tr>
                  <tr>
                    <td class="signature-td">Imie</td>
                    <td class="signature-td">{{ item.sign.subject.given_name || "Brak" }}</td>
                  </tr>
                  <tr>
                    <td class="signature-td">Nazwisko</td>
                    <td class="signature-td">{{ item.sign.subject.surname || "Brak"}}</td>
                  </tr>
                  <tr>
                    <td class="signature-td">Kraj:</td>
                    <td class="signature-td">{{ item.sign.subject.country_name || "Brak" }}</td>
                  </tr>
                </table>
              </v-container>
            </v-card>
          </v-tab-item>

          <v-tab ripple >
            Wystawca
          </v-tab>
          <v-tab-item>
            <v-card flat>
              <v-container >
                <table v-if="item.sign" class="signature-table">
                  <tr>
                    <td class="signature-td">Nazwa</td>
                    <td class="signature-td">{{ item.sign.issuer.common_name || "Brak" }}</td>
                  </tr>
                  <tr>
                    <td class="signature-td">Firma</td>
                    <td class="signature-td">{{ item.sign.issuer.organization_name || "Brak" }}</td>
                  </tr>
                  <tr>
                    <td class="signature-td">Identyfikator</td>
                    <td class="signature-td">{{ item.sign.issuer.organization_identifier || "Brak"}}</td>
                  </tr>
                  <tr>
                    <td class="signature-td">Kraj:</td>
                    <td class="signature-td">{{ item.sign.issuer.country_name || "Brak" }}</td>
                  </tr>
                </table>
              </v-container>
            </v-card>
          </v-tab-item>
        </v-tabs>

      </div>
    </v-sheet>
  </v-dialog>
</template>

<script>
export default {
  props:['idDoc'],
  name: "CheckSignature",
  data(){
    return {
      item : {},
      dialog: false,
      active : 0
    }
  },
  methods: {
    checkSign() {
      this.$http.get(`document/${this.idDoc}/signature/check`).then(data =>{
        this.item = data.data
      })
    }
  },
  watch: {
    dialog: function(){
      if(this.item.sign == undefined) {
        this.checkSign()
      }
    }
  }
}
</script>

<style scoped>
.signature-table{
  border-collapse: collapse;
  border: 1px solid;
}
.signature-td{
  border: 1px solid;
  text-align: center;
  padding: 1rem 1rem;
}
</style>